import React, { Component } from "react";
import {
  Typography,
  Grid,
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  Chip,
} from "@material-ui/core";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { Button, FormControl, Card } from "react-bootstrap";
import { PostData, GetData, DeleteData, PutData } from "../../api/service";
import Snack from "../Snackbar/Snack";
import FileUpload from "../AddNew/FileUpload";
import Edit from "@material-ui/icons/Edit";
import Delete from "@material-ui/icons/Delete";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import history from "../../history";

class FacultyResourcePerson extends Component {
  state = {
    m_type: this.props.m_type,
    employee_id: this.props.employee_id,
    email: this.props.email,
    message: "",
    open: false,
    isLoaded: false,
    topic: "",
    organisation: "",
    date: "",
    year: "",
    details: "",
    resource_person: [],
  };

  handleChangeInput = (name, value, index, array) => {
    let d = this.state[array];
    d[index][name] = value;
    this.setState({
      [array]: d,
    });
  };

  handleChange = (name, value) => {
    this.setState({
      [name]: value,
    });
  };

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  componentDidMount() {
    //console.log(this.props);

    GetData(`/admin/${this.props.employee_id}/getsingleempolyeedataapi`).then(
      (resp) => {
        if (resp) {
          this.setState({
            ...resp,
          });
        }
        this.setState({
          isLoaded: true,
        });
      }
    );
  }

  //   componentDidUpdate(prevProps){
  //     if(this.props !== prevProps){
  //         this.setState({
  //             seminar:this.props.seminar

  //         })
  //     }
  // }

  onSubmit = (e) => {
    e.preventDefault();

    let d = this.state;

    PostData(`/admin/${this.props.employee_id}/addemployeeapi`, d).then(
      (resp) => {
        //console.log(resp)
        this.setState({
          message: resp,
          open: true,
        });
      }
    );
  };

  onAddClick = () => {
    let d = {
     

      topic: this.state.topic,
    organisation: this.state.organisation,
    date:this.state.date,
    year: this.state.year,
    details: this.state.details,
    };

    let resource_person =
      this.state.resource_person != null ? this.state.resource_person : [];
      resource_person.push(d);
    this.setState(
      {
        resource_person,
      },
      () => {
        this.setState({
          topic: "",
    organisation: "",
    date: "",
    year: "",
    details: "",
        });
      }
    );
  };

  onDelete = (index) => {
    let resource_person = this.state.resource_person;
    resource_person.splice(index, 1);

    this.setState({
      resource_person,
    });
  };

  render() {
    return (
      <div>
        {this.state.open ? (
          <Snack
            open={this.state.open}
            message={this.state.message}
            handleClose={() => {
              this.setState({
                open: false,
                message: "",
              });
            }}
          />
        ) : null}

        {this.state.isLoaded && (
          <form onSubmit={this.onSubmit}>
            <Typography variant="h6" gutterBottom>
              {this.props.title}
            </Typography>

            <table width="100%" className="table">
              <thead>
                <tr>
                  <td>Topic</td>
                  <td>Organisation</td>
                  <td>Date</td>
                  <td>Year</td>
                  <td>Details if any</td>
                

                  <td>Click + to Add</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <input
                      className="form-control"
                      type="text"
                      name="topic"
                      value={this.state.topic}
                      onChange={this.onChange}
                      placeholder="Topic"
                    />
                  </td>
                  <td>
                    <input
                      className="form-control"
                      type="text"
                      name="organisation"
                      value={this.state.organisation}
                      onChange={this.onChange}
                      placeholder="Organisation"
                    />
                  </td>

                  <td>
                    <input
                      className="form-control"
                      type="date"
                      name="date"
                      value={this.state.date}
                      onChange={this.onChange}
                      placeholder="Date"
                    />
                  </td>

                  <td>
                    <input
                      className="form-control"
                      type="text"
                      name="year"
                      value={this.state.year}
                      onChange={this.onChange}
                      placeholder="Year"
                    />
                  </td>

                  <td>
                    <input
                      className="form-control"
                      type="text"
                      name="details"
                      value={this.state.details}
                      onChange={this.onChange}
                      placeholder="Details if any"
                    />
                  </td>
                 

                 

                  <td>
                    <Button
                      variant="outlined"
                      onClick={this.onAddClick}
                      type="button"
                    >
                      +
                    </Button>
                  </td>
                </tr>
              </tbody>
              <tbody>
                {Array.isArray(this.state.resource_person) &&
                  this.state.resource_person.map((el, index) => (
                    <tr key={index}>
                      <td>
                        <input
                          className="form-control"
                          type="text"
                          name="topic"
                          rows={5}
                          value={el.topic}
                          onChange={(e) =>
                            this.handleChangeInput(
                              "topic",
                              e.target.value,
                              index,
                              "resource_person"
                            )
                          }
                          placeholder="Topic"
                        />
                      </td>

                      <td>
                        <input
                          className="form-control"
                          type="text"
                          name="organisation"
                          rows={5}
                          value={el.organisation}
                          onChange={(e) =>
                            this.handleChangeInput(
                              "organisation",
                              e.target.value,
                              index,
                              "resource_person"
                            )
                          }
                          placeholder="Organisation"
                        />
                      </td>

                      <td>
                        <input
                          className="form-control"
                          type="date"
                          name="date"
                          rows={5}
                          value={el.date}
                          onChange={(e) =>
                            this.handleChangeInput(
                              "date",
                              e.target.value,
                              index,
                              "resource_person"
                            )
                          }
                          placeholder="Date"
                        />
                      </td>

                      <td>
                        <input
                          className="form-control"
                          type="text"
                          name="year"
                          rows={5}
                          value={el.year}
                          onChange={(e) =>
                            this.handleChangeInput(
                              "year",
                              e.target.value,
                              index,
                              "resource_person"
                            )
                          }
                          placeholder="Year"
                        />
                      </td>

                      <td>
                        <input
                          className="form-control"
                          type="text"
                          name="details"
                          rows={5}
                          value={el.details}
                          onChange={(e) =>
                            this.handleChangeInput(
                              "details",
                              e.target.value,
                              index,
                              "resource_person"
                            )
                          }
                          placeholder="Details if any"
                        />
                      </td>

                    
                      

                      <td>
                        <Delete onClick={this.onDelete.bind(this, index)} />
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
            <br />
            <div align="right">
              <Button size="sm" variant="info" type="submit">
                Submit
              </Button>
            </div>
          </form>
        )}
      </div>
    );
  }
}

export default FacultyResourcePerson;
